<template>
  <div class="group-btn" @click="handle">
    <img class="group_logo" :src="require(`${logo}`)" alt="" />
    <span class="group_text" :class="{ text_min: minWidth }">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    logo: String,
    text: String,
    minWidth: Boolean,
  },
  methods: {
    handle() {
      this.$emit("handleClick")
    },
  },
}
</script>

<style lang="scss" scoped>
.group-btn {
  height: 40px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  .group_logo {
    width: 20px;
    height: 20px;
  }
  .group_text {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    &.text_min {
      min-width: 38px;
      text-align: center;
    }
  }
}
</style>
